import { ArrowLeftIcon } from '@untitledui-icons/react/line'

interface StepHeaderProps {
  title: string
  subtitle?: string
  onBack?: () => void
  showBack?: boolean
}

export function StepHeader({ title, subtitle, onBack, showBack = true }: StepHeaderProps) {
  return (
    <div className="mb-6 flex flex-col gap-6 lg:gap-4">
      {showBack && onBack && (
        <button
          onClick={onBack}
          className="flex h-6 w-6 cursor-pointer items-center justify-center text-[#181d27] transition-colors hover:text-[#414651]"
          type="button"
        >
          <ArrowLeftIcon className="h-6 w-6" />
        </button>
      )}
      
      <div className="flex flex-col">
        <h1 className="text-[30px] font-semibold leading-[38px] tracking-normal text-black">
          {title}
        </h1>
        
        {subtitle && (
          <p className="mt-2 text-base font-normal leading-6 text-black">
            {subtitle}
          </p>
        )}
      </div>
    </div>
  )
}
